(function () {
function $4e80cf122b9d3f49$var$initializeFaqBlock(root) {
    if (!root || root.dataset.faqInitialized === 'true') return;
    var faqItems = root.querySelectorAll('.faq__item');
    if (!faqItems.length) return;
    root.dataset.faqInitialized = 'true';
    // Delegated on root rather than attaching a listener per item found at
    // init time: querySelectorAll returns a static snapshot, and the editor
    // canvas can re-render items inside an already-initialized root (ACF
    // updates the preview in place on field changes without necessarily
    // replacing the root node) — a one-time snapshot would leave newly added
    // items with no click handler and keep referencing removed ones.
    root.addEventListener('click', function(event) {
        var question = event.target.closest('.faq__question');
        if (!question) return;
        var item = question.closest('.faq__item');
        var answer = item ? item.querySelector('.faq__answer') : null;
        if (!item || !answer) return;
        var isOpen = item.classList.contains('faq__item--open');
        // Close all other FAQ items. Queried fresh on every click, scoped to
        // this block's own document (the frontend page, or the editor canvas
        // iframe) via root.ownerDocument, matching the original single-document
        // behavior while staying correct inside the iframe realm.
        root.ownerDocument.querySelectorAll('.faq__item').forEach(function(otherItem) {
            if (otherItem !== item) {
                otherItem.classList.remove('faq__item--open');
                var otherQuestion = otherItem.querySelector('.faq__question');
                var otherAnswer = otherItem.querySelector('.faq__answer');
                if (otherQuestion) otherQuestion.setAttribute('aria-expanded', 'false');
                if (otherAnswer) otherAnswer.style.maxHeight = null;
            }
        });
        // Toggle current item
        if (isOpen) {
            item.classList.remove('faq__item--open');
            question.setAttribute('aria-expanded', 'false');
            answer.style.maxHeight = null;
        } else {
            item.classList.add('faq__item--open');
            question.setAttribute('aria-expanded', 'true');
            answer.style.maxHeight = "".concat(answer.scrollHeight, "px");
        }
    });
// Popup functionality is handled by the global embed-popup.js component
// (instantiated separately per-document; see src/js/_editor.js for the
// editor canvas). The FAQ block uses the legacy 'faq-popup' class names
// which are aliased to the new 'embed-popup' classes via SCSS @extend for
// backward compatibility.
}
function $4e80cf122b9d3f49$var$initializeFrontend() {
    document.querySelectorAll('.faq').forEach($4e80cf122b9d3f49$var$initializeFaqBlock);
}
if (window.acf) window.acf.addAction('render_block_preview/type=faq', function($block) {
    $4e80cf122b9d3f49$var$initializeFaqBlock($block.get(0));
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $4e80cf122b9d3f49$var$initializeFrontend);
else $4e80cf122b9d3f49$var$initializeFrontend();

})();
//# sourceMappingURL=script.js.map
